import { render, staticRenderFns } from "./panel-template.vue?vue&type=template&id=b7c52c5a"
import script from "./panel-template.vue?vue&type=script&lang=js"
export * from "./panel-template.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports